import React from 'react';

import PropTypes from 'prop-types';

import OptionGroup from './OptionGroup';

import { useCarsState } from '../providers/CarsProvider';

const OptionCategory = ( { id, slug, label, groups, colors } ) => {

    const [ carsState, carsDispatch ] = useCarsState();

    const handleOnClick = () => {

        carsDispatch( { type:'setSelectedCategory', data:{ id, slug, groups, label } } );
    }

    const selected = carsState.selectedCategory && carsState.selectedCategory.id == id;

    return <div style={{cursor : selected ? 'auto' : 'pointer', borderRadius:4, background: selected ? 'rgba(30,30,30,.9)' : colors['secondary'] }} className={`p-2 flex-grow-1`} onClick={ handleOnClick } >
        <h5 className={ selected ? 'bold' : 'semi-bold'  } style={{color: selected ? '#ffffff' : '#333333'}}>{ label }</h5>
        { groups && <div style={{ pointerEvents: selected ? 'all' : 'none', display: selected ? 'flex' : 'none', gap:4}} className="d-flex flex-column pr-1 py-2">
            { groups.map( group => (
                <OptionGroup key={`option-group-${ group.id }`} { ...group } />
            )) }
        </div> }
    </div>
}

OptionCategory.propTypes = {
    id: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    groups: PropTypes.array, 
    colors: PropTypes.object.isRequired
}

export default OptionCategory;